import { Pipe, PipeTransform } from '@angular/core';
import { MissionRequest } from '../../models/mission/mission-request';

@Pipe({
	name: 'filterFormationBySpeciality'
})
export class FilterFormationBySpecialityPipe implements PipeTransform {
	transform(formations: MissionRequest[], filter: string): MissionRequest[] {
		if (formations === null || filter === '') {
			return formations;
		}

		return formations.filter((missionRequest) =>
			missionRequest.missionPlace?.specialties[0].name
				.toLowerCase()
				.includes(filter.toLowerCase())
		);
	}
}
